import { render, staticRenderFns } from "./NavbarMainLogo.vue?vue&type=template&id=47f196dc&"
import script from "./NavbarMainLogo.vue?vue&type=script&lang=js&"
export * from "./NavbarMainLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports